import React, { useState, useEffect } from "react";
import Form from "../../../../Components/Form";
import TextInput from "../../../../Components/Form/TextInput";
import Category from "../../../../APIController/Category";
import Text from "../../../../Components/Text";
import ColorPicker from "../../../../Components/Form/ColorPicker";
import NumberInput from "../../../../Components/Form/NumberInput";

const CategoryForm = ({ selectedCategory = null, afterAction }) => {
    /* Values for Categorys */
    const [categoryName, setCategoryName] = useState('')
    const [categoryColor, setCategoryColor] = useState(null);
    const [catIndex, setCatIndex] = useState(null)
    const {
        addCategory,
        editCategory
    } = Category();

    const handleAddCategory = async (categoryDTO) => {
        await addCategory(categoryDTO);
        afterAction()
    };

    const handleEditCategory = async (categoryId, categoryDTO) => {
        await editCategory(categoryId, categoryDTO);
        afterAction()
    };

    /* Edit handler  */
    useEffect(() => {
        if (selectedCategory) {
            setCategoryName(selectedCategory.name);
            setCategoryColor(selectedCategory.colorCode);
            setCatIndex(selectedCategory.index)
        }
    }, []);

    /* Submit form function for category */
    const handleSubmit = (e) => {
        e.preventDefault()
        const categoryDTO = {
            name: categoryName,
            colorCode: categoryColor,
            index: catIndex
        };
        if (selectedCategory) {
            handleEditCategory(selectedCategory.id, categoryDTO);
        } else {
            handleAddCategory(categoryDTO);
        }
        setCategoryName("");
    }

    return (
        <Form onSubmitAction={handleSubmit} submitButtonText={selectedCategory ? "Kategorie bearbeiten" : "Kategorie erstellen"}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}>{selectedCategory ? "Kategorie bearbeiten" : "Kategorie erstellen"}</Text>
            <TextInput attribute={categoryName} id={"categoryName"} label={"Name"} placeholder={"Kategorie Name"} action={(e) => setCategoryName(e.target.value)} />
            <NumberInput
                attribute={catIndex}
                id={"catIndex"}
                label={"Reihenfolge"}
                action={(e) => setCatIndex(e.target.value)}
            />
            <ColorPicker action={(color) => setCategoryColor(color)} label={"Farbe"} initialColor={categoryColor} />
        </Form>
    );
}
export default CategoryForm